<div [id]="getId()" class="modal modal-lg" data-backdrop="static" data-keyboard="false" role="dialog" tabindex="-1">
    <div class="modal-dialog" role="document">
        <div class="modal-content">

            @if (!applicationStateService.isOfflineModeEnabled) {
                <div class="modal-header">
                    <h4 class="modal-title">Buchbestellung und Download</h4>
                    <button class="btn-close" data-bs-dismiss="modal" title="Schließen" type="button"></button>
                </div>
            }

            @if (applicationStateService.isOfflineModeEnabled) {
                <div class="modal-header">
                    <h4 class="modal-title">Informationen zum Buch</h4>
                    <button class="btn-close" data-bs-dismiss="modal" title="Schließen" type="button"></button>
                </div>
            }

            <div class="modal-body">
                @if (!applicationStateService.isOfflineModeEnabled) {
                    <div class="row row-actions">
                        <div class="col-md-3 col-sm-6 buttons">
                            <a [attr.data-bs-toggle]="!applicationStateService.bookConfig.storeLink ? 'tooltip' : null"
                               [attr.href]="applicationStateService.bookConfig.storeLink"
                               [attr.title]="!applicationStateService.bookConfig.storeLink ? 'Dieses Buch kann leider nicht als E-Book gekauft werden.' : null"
                               [class.disabled]="!applicationStateService.bookConfig.storeLink"
                               [position]="'center 15px'"
                               [size]="'50px'"
                               [url]="'/sidebar-quicklinks/store-at-logo.png' | asset"
                               backgroundImage
                               data-bs-placement="bottom"
                               target="_blank">
                <span class="content">
                  <span>
                    E-Book kaufen
                  </span>
                  <span>
                    (Digitales Blätterbuch)
                  </span>
                </span>
                            </a>
                        </div>
                        <div class="col-md-3 col-sm-6 buttons">
                            <a [attr.data-bs-toggle]="!applicationStateService.bookConfig.productLink ? 'tooltip' : null"
                               [attr.href]="applicationStateService.bookConfig.productLink"
                               [attr.title]="!applicationStateService.bookConfig.productLink ? 'Dieses Buch ist leider nicht als Printbuch bestellbar.' : null"
                               [class.disabled]="!applicationStateService.bookConfig.productLink"
                               [position]="'center 15px'"
                               [size]="'50px'"
                               [url]="'/sidebar-quicklinks/icon-book-shop.png' | asset"
                               backgroundImage
                               data-bs-placement="bottom"
                               target="_blank">
                <span class="content">
                  <span>
                    Bestellung
                  </span>
                  <br/>
                  <span>
                    (Gedrucktes Buch)
                  </span>
                </span>
                            </a>
                        </div>
                        @if (applicationStateService.userData.isTeacher) {
                            <div class="col-md-3 col-sm-6 buttons">
                                <a [attr.data-bs-toggle]="!applicationStateService.userData.isTeacher || !applicationStateService.bookConfig.freeDownloadLink ? 'tooltip' : null"
                                   [attr.href]="applicationStateService.bookConfig.freeDownloadLink"
                                   [attr.title]="!applicationStateService.userData.isTeacher || !applicationStateService.bookConfig.freeDownloadLink? 'Dieses Buch kann leider nicht als PDF heruntergeladen werden.' : null"
                                   [class.disabled]="!applicationStateService.userData.isTeacher || !applicationStateService.bookConfig.freeDownloadLink"
                                   data-bs-placement="bottom"
                                   target="_blank">
                                    <i class="fas fa-file-download"></i>
                                    <span class="content">
                                        <span>
                                            PDF-Download
                                         </span>
                                        <br/>
                                        <span>
                                            (ganzes Buch - kostenlos)
                                        </span>
                                    </span>
                                </a>
                            </div>
                        }
                    </div>
                }

                @if (!applicationStateService.isOfflineModeEnabled) {
                    <h4>Informationen zum Buch</h4>
                }
                @if (applicationStateService.bookConfig.lastPage) {
                    <div class="text-center pages-count">
                        {{ applicationStateService.bookConfig.lastPage }} Seiten
                    </div>
                }

                <br/>

                <app-book-info></app-book-info>

                @if (applicationStateService.bookConfig.otherEditions && applicationStateService.bookConfig.otherEditions.length > 0 && !applicationStateService.isOfflineModeEnabled) {
                    <div
                            class="row">
                        <div class="modal-footer">
                            <label>Auflage wechseln </label>
                            <app-editions-dropdown></app-editions-dropdown>
                        </div>
                    </div>
                }

            </div>
        </div>
    </div>
</div>
